module.exports = __webpack_public_path__ + "static/zoomcreations-56cee90ad26a506d3efd91ee1e0ed520.jpg";